import { render, staticRenderFns } from "./navigation-main.vue?vue&type=template&id=d6a09eee&"
import script from "./navigation-main.vue?vue&type=script&lang=js&"
export * from "./navigation-main.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports